import React from 'react'
import { useMutation } from '@apollo/client'

import { toast } from 'react-toastify'
import { DELETE_BOT_BY_APPID } from '../../../graphql/mutation'
import axios from 'axios'

interface Props {
  bot: any
  fetchBots: any
  closeDeleteModal: () => void
}

const DeleteAiBot: React.FC<Props> = ({ bot, fetchBots, closeDeleteModal }) => {
  const [deleteBot, { loading: loadingDeleteBot }] = useMutation(DELETE_BOT_BY_APPID, {
    context: {
      headers: {
        'access-control-allow-methods': 'Bot-Builder'
      }
    }
  })

  // const deleteThisBot = (applicationId: number) => {

  // deleteBot({
  //     variables: {
  //         input: {
  //             applicationId
  //         }
  //     }
  // })
  //     .then((res: any) => {

  //         closeDeleteModal()
  //         if (parseInt(res.data.deleteApplicationById.status) === 200) {
  //             toast.success('Succesfully deleted the Bot')
  //         } else {
  //             toast.error('Unable to delete bot')
  //         }
  //     })
  //     .catch((err) => {

  //         toast.error('Sorry! Unexpected Error.')
  //         console.log(err)
  //     })
  // }
  const deleteThisBot = async (
    botId: number,
    botName: string,
    appId: string,
    description: string
  ) => {
    try {
      const token = localStorage.getItem('auth-token')

      const params = new URLSearchParams()
      params.append('bot_name', botName)
      params.append('app_id', appId)
      params.append('description', description)

      const response = await axios.delete(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/ai-chatbots/delete_bot/${botId}`,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`
          },
          data: params.toString() // send as URL encoded string
        }
      )

      if (response.status === 200) {
        toast.success('Successfully deleted the Bot')
        closeDeleteModal()
        fetchBots()
      } else {
        toast.error('Unable to delete bot')
      }
    } catch (error) {
      toast.error('Sorry! Unexpected Error.')
      console.error(error)
    }
  }

  return (
    <div className='card-body'>
      <p className='fs-5 fw-bold'>Are you sure you want to delete the following Bot ?</p>
      <div className='card-text'>
        Bot Name: <strong>{bot.name}</strong>
      </div>
      <div className='card-text'>
        Bot Description: <strong>{bot.description}</strong>
      </div>

      <div className='d-flex justify-content-end mt-10'>
        <button
          type='reset'
          className='btn btn-sm btn-white btn-active-light-primary me-2'
          onClick={closeDeleteModal}
        >
          Cancel
        </button>

        <button
          type='button'
          className='btn btn-sm btn-danger'
          disabled={loadingDeleteBot}
          onClick={() => deleteThisBot(bot.id, bot.name, bot.app_id, bot.description)}
        >
          {!loadingDeleteBot && <span className='indicator-label'>Delete</span>}
          {loadingDeleteBot && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}

export default DeleteAiBot
